import fileSys from "../../../fileoprators/fileSystem";
import { INVALID_1000 } from "../../../shared/consts";
import DryEyeApiNode from "./DryEyeApiNode";
import { isDefined } from "../../../shared/utils";
import moment from "moment";
const meibomianApi = window.__dryeye__.debug
  ? DryEyeApiNode
  : window.require(fileSys.getUtilPath("meibomianApi.node"));
const meibomianEnhance = window.__dryeye__.debug
  ? DryEyeApiNode
  : window.require(fileSys.getUtilPath("meibomianEnhance.node"));
const tearHeightApi = window.__dryeye__.debug
  ? DryEyeApiNode
  : window.require(fileSys.getUtilPath("tearApi.node"));
const eyeRednessApi = window.__dryeye__.debug
  ? DryEyeApiNode
  : window.require(fileSys.getUtilPath("eyeRednessApi.node"));
const eyelidEdgeApi = window.__dryeye__.debug
  ? DryEyeApiNode
  : window.require(fileSys.getUtilPath("eyelidedgeApi.node"));
// let dryEyeApiNode = window.__dryeye__.debug ? DryEyeApiNode : window.require(fileSys.getUtilPath('DryEyeApi.node'))
class DryEyeApi {
  constructor() {
    this.generateImages = fileSys.getMediaPath();
  }

  calcTearHeight(filepath, type = "bg") {
    let result = {};
    result = tearHeightApi.TearHeight(
      filepath,
      this.generateImages,
      fileSys.getUtilPath(type === "bg" ? "tearc" : "tearchw"),
      fileSys.getUtilPath(type === "bg" ? "tearcnt" : "tearcnthw"),
      fileSys.getUtilPath(type === "bg" ? "tearh" : "tearhhw")
    );

    if (result) {
      return result;
    }
  }
  calcMebomian(filepath, upDown, points) {
    let direction = upDown === "up" ? 0 : 1;
    let percent = new Float64Array(1);
    let loss = new Float64Array(1);
    let result = {};
    percent.fill(INVALID_1000);
    loss.fill(INVALID_1000);
    if (isDefined(points)) {
      let a = Int32Array.from(points);

      result = meibomianApi.Meibomian(
        filepath,
        this.generateImages,
        fileSys.getUtilPath("meibo"),
        window.magecoe.meibomian,
        direction,
        a.buffer
      );
    } else {
      let a = new Int32Array(1);

      result = meibomianApi.Meibomian(
        filepath,
        this.generateImages,
        fileSys.getUtilPath("meibo"),
        window.magecoe.meibomian,
        direction,
        a.buffer
      );
    }
    if (result) {
      return result;
    }
  }
  enhanceMeibomianImg(filepath) {
    // ${moment().format('YYYY-MM-DD HH:mm:ss')}
    let result = meibomianEnhance.MeibomianEnhance(
      filepath,
      `${filepath}`,
      fileSys.getUtilPath("mbenai520")
    );

    // let result = meibomianEnhance.MeibomianEnhance(filepath, `${fileSys.getCfgPath(moment().format('HH:mm:ss.SSS'))}.jpg`, fileSys.getUtilPath('mbenai520'))
    return result;
  }
  calcEyelidEdge(filepath, start, end) {
    let result = eyelidEdgeApi.EyelidEdge(filepath, this.generateImages, start, end);
    return result;
  }
  calcEyeRedness(filepath) {
    let congestionBulbarNasal = new Float64Array(1);
    let congestionBulbarTemp = new Float64Array(1);
    let congestionCiliaryNasal = new Float64Array(1);
    let congestionCiliaryTemp = new Float64Array(1);
    congestionBulbarNasal.fill(INVALID_1000);
    congestionBulbarTemp.fill(INVALID_1000);
    congestionCiliaryNasal.fill(INVALID_1000);
    congestionCiliaryTemp.fill(INVALID_1000);
    let result = eyeRednessApi.EyeRedness(
      filepath,
      this.generateImages,
      fileSys.getUtilPath("eyewhite")
    );

    return result;
    // if (result && result.result === 0) {
    //   return {
    //     congestionBulbarNasal: 0.12,
    //     congestionBulbarTemp: 0.16,
    //     congestionCiliaryNasal: 0.06,
    //     congestionCiliaryTemp: 0.11
    //   }
    // } else if (result) {
    // }
  }
}
export default DryEyeApi;



// WEBPACK FOOTER //
// ./src/dryeye/js/algorithm/DryEyeApi.js